import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MessagesViewComponent } from './messages.component';

@NgModule({
  declarations: [MessagesViewComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [MessagesViewComponent]
})
export class MessagesModule { }
